import { withDisplayName } from '@hocs/with-display-name'
import {
  ENHANCED_COMPONENT_ROLE,
  ENHANCED_COMPONENT_TYPE,
} from '@ui/enhanced-components/types'
import { Hyperlink } from '@ui/hyperlink'
import { getPath } from '@utils/get-path'
import { graphql } from 'gatsby'
import React from 'react'

const ContentfulCtaSecondary: Utils.EntryFC<
  Queries.ContentfulCtaSecondaryFragment
> = ({ content: { text, externalLink, internalLink } }) => {
  const href = getPath(internalLink) || externalLink || undefined

  return (
    <Hyperlink
      data-role={ENHANCED_COMPONENT_ROLE.SECONDARY}
      data-type={ENHANCED_COMPONENT_TYPE.CTA}
      href={href}
    >
      {text}
    </Hyperlink>
  )
}

export const query = graphql`
  fragment ContentfulCtaSecondary on ContentfulCta {
    ...ContentfulEntry
    text
    internalLink {
      ...ContentfulBlogTagLink
      ...ContentfulBlogArticleLink
      ...ContentfulDeprecatedPageLink
    }
    externalLink
  }
`

export default withDisplayName(ContentfulCtaSecondary, 'ContentfulCtaSecondary')
